export default {
  install(Vue) {
    Vue.prototype.$isMobileSize = () => {
      return window.innerWidth < 960;
    }
  }
};
